import { ApplicationConfig, CSP_NONCE, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withHashLocation, withInMemoryScrolling, withRouterConfig, withViewTransitions } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { IconSetService } from '@coreui/icons-angular';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { APP_NONCE, CSP_TOKEN, EnvironmentNonceServiceFactory, EnvironmentServiceFactory, UiServiceEnvironment, UiServiceTokenInterceptor } from '@drct-web-apps/ui-services';


export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      }),
      withEnabledBlockingInitialNavigation(),
      withViewTransitions(),
      withHashLocation()),
      IconSetService,
      provideAnimations(),
      provideHttpClient(),
      { provide: HTTP_INTERCEPTORS, useClass: UiServiceTokenInterceptor, multi: true },
      { provide: UiServiceEnvironment, useFactory: EnvironmentServiceFactory },
      { provide: CSP_TOKEN, useValue: APP_NONCE },
      { provide: CSP_NONCE, useFactory: EnvironmentNonceServiceFactory, deps: [ UiServiceEnvironment ] }
  ],
};
